import styled from 'styled-components'

export const UsuarioConsultaBox = styled.div`

`

UsuarioConsultaBox.PrintHeader = styled.div`
    font-size: 12px;
    width: -webkit-fill-available;
    display: table;
    background-color: #e3e0e0;
    text-align: center;
    border: solid 3px;
    border-color: #000000;
`

UsuarioConsultaBox.PrintColumn = styled.div`
    display: table-cell; 
    padding: 0 5px 0 5px;
    width: 10%;
`

UsuarioConsultaBox.PrintColumnComunicacao = styled.div`
    display: table-cell; 
    padding: 0 5px 0 5px;
    min-width: 85px;
    max-width: 85px;
`

UsuarioConsultaBox.PrintColumnDestinatario = styled.div`
    display: table-cell; 
    padding: 0 5px 0 5px;
    min-width: 90px;
    max-width: 90px;
`

UsuarioConsultaBox.PrintColumnProcesso = styled.div`
    display: table-cell; 
    padding: 0 5px 0 5px;
    min-width: 100px;
    max-width: 100px;
`

UsuarioConsultaBox.PrintBody = styled.div`
    font-size: 10px;
    background-color: #ffffff;
    text-align: center;
    border: solid 3px;
    border-color: #000000;
`

UsuarioConsultaBox.PrintBodyLine = styled.div`
    width: -webkit-fill-available;
    display: table;    
`

UsuarioConsultaBox.Paginacao = styled.div`
    text-align: center;
    padding-bottom: 30px;
    padding-top: 10px;
`

UsuarioConsultaBox.Exportacao = styled.div`
    display: inline-flex;
    position: relative;
    left: 16%;
`

UsuarioConsultaBox.ExportacaoAcao = styled.div`
    padding: 0 5px 0 5px
`

UsuarioConsultaBox.PrintPage = styled.div`
    @page {
        margin: 30px 10px 20px 10px;
    }
  
    .div-impressao  {
        page-break-after: always;
        break-after: page;
    }
`

UsuarioConsultaBox.BotaoAcao = styled.button`
    min-width: 0;
    padding: 0;
    width: 50px;
    height: 50px;
    display: table-column;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    border: 2px solid;
    transition: all ease .35s;
    cursor: pointer;
    margin: 3px 5px 0 5px;
    float: right;
    padding-top: 4px;

    .MuiButton-root svg {
        font-size: 19px;
    } 
`